import React, { useState, useCallback, useEffect } from "react";
import Delete from "../../assets/img/stm-delete.svg";
import Translations from "../../services/translation.service";
import OfferModal from "./offers.popoup.js";
import Storage from "../../services/storage.service";
import Offers from "../../services/offers.service";
import DeletePopup from "./storefront-delete-popup";
import checkModule from "./checkModule.js";
import Skeleton from "./skeleton-component";
import FirebaseAnalytics from "../../services/analytics.service";

let prefix = "stm_sum_";
const SummaryOfferSection = ({
  getSummary,
  selectedCard,
  appliedOffer,
  setAppliedOffer,
  setOffersFetchedInitially
}) => {
  const [isOffersModal, setOffersModal] = useState(false);
  const [offersList, setOffersList] = useState({});
  const [unGroupedOffers, setUnGroupedOffers] = useState([]);
  const [activeOffers, setActiveOffers] = useState([]);
  const [modalLoader, setModalLoader] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [isError, setError] = useState(false);
  const [appliedList, setAppliedList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [offersData, setOffersData] = useState([]);
  const [isDeletePopup, setDeletePopup] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const toggleOffersModal = () => {
    setOffersModal((prev) => !prev);
  };

  const toggleDeleteModal = () => {
    setDeletePopup((prev) => !prev);
  };

  const handleAppliedOffers = (key, value) => {
    const updatedAppliedOffer = { ...appliedOffer };
    if (value) {
      updatedAppliedOffer[key] = value;
    } else {
      delete updatedAppliedOffer[key]
    }
    Storage.set(
      "offer_applied_promotion_id",
      Object.values(updatedAppliedOffer),
      true
    );
    Storage.set(
      "offer_applied_promotion_object",
      JSON.stringify(updatedAppliedOffer),
      true
    );
    if (setAppliedOffer) {
      setAppliedOffer(updatedAppliedOffer);
    }

  };

  const checkPreActiveOffer = useCallback(
    (offer) => {
      const presSelectedPlan =
        selectedCard || Storage.get("predefined_selected_plan", true) ? JSON.parse((Storage.get("predefined_selected_plan", true) || "{}")) : {};
      if (presSelectedPlan?.Promotions?.length) {
        return presSelectedPlan?.Promotions.some(
          (item) => item.PromotionCode === offer.PromotionId && !!item.IsMetrics
        );
      } else {
        return false;
      }
    },
    [selectedCard]
  );

  const sortPlanIdsFromOffer = (planIds) => {
    const output = [];
    if(planIds && planIds.length > 0) {
      planIds.forEach((innerArray) => {
        // Sorting each inner array in ascending order
        innerArray.sort((a, b) => a - b);
        output.push(innerArray);
      });
    }
    return output
  }

  const formattedOffers = useCallback((data, selectedPlanCard) => {
    const offers = {};
    const unGroupedOffers = [];
    const appliedOffer = [];
    const activeOffers = [];
    
    let cardMatchingKeys = "";
    if(selectedPlanCard?.Plan?.length){
      const collectPlanIDs = [];
      selectedPlanCard.Plan.forEach(item => {
        collectPlanIDs.push(item?.PlanID);
      });
      cardMatchingKeys = collectPlanIDs.toSorted();
      cardMatchingKeys = cardMatchingKeys.join(",");
    }

    const filterDataByPlanIds = (data, planIds) => {
      if(Storage.get("selected_plan_id", true)){
        planIds = Storage.get("selected_plan_id", true);
      }
      const idsToMatch = planIds?.split(',').sort(); // Split the input string of planIds and sort them
      return data.filter(entry => {
          const sortedEntryPlanIds = entry.PlanIds; // Sort the planIds of each entry
          const sortedPlanIDsFromOffer = sortPlanIdsFromOffer(sortedEntryPlanIds).map(innerArray => innerArray.map(Number));
          const sortedPlanIDsSelected = idsToMatch.map(Number);      
          return sortedPlanIDsFromOffer.some(innerArray => {
            return innerArray.every(num => sortedPlanIDsSelected.includes(num));
          });; // Compare the sorted planIds
      });
    }

    let filteredOffersForPlan = filterDataByPlanIds(data, cardMatchingKeys);
    // Information: 
    // Remove below line to show offers only related to selected plan.
    // filteredOffersForPlan = data;

    filteredOffersForPlan.forEach((item) => {
      if (item.IsApplied) {
        appliedOffer.push(item);
      }
      if (checkPreActiveOffer(item)) {
        activeOffers.push(item)
      } else if (item.GroupName && offers[item.GroupName]) {
        offers[item.GroupName].push(item);
      } else if (item.GroupName) {
        offers[item.GroupName] = [item];
      } else {
        unGroupedOffers.push(item);
      }
    });
    return { offers, unGroupedOffers, appliedOffer, activeOffers };
  }, [checkPreActiveOffer]);

  const setPreSelectedOffers = useCallback(
    (list) => {
      const appliedOffer = {};
      list.forEach((item) => {
        if (item.IsApplied) {
          appliedOffer[item.GroupName] = item.PromotionId;
        }
      });
      Storage.set(
        "offer_applied_promotion_id",
        Object.values(appliedOffer),
        true
      );
      Storage.set(
        "offer_applied_promotion_object",
        JSON.stringify(appliedOffer),
        true
      );
      if (Object.values(appliedOffer).length && setAppliedOffer) {
        setAppliedOffer(appliedOffer);
      }
    },
    [setAppliedOffer]
  );

  useEffect(() => {
    const { offers, unGroupedOffers, appliedOffer, activeOffers } = formattedOffers(offersData, selectedCard);
    setOffersList(offers || {});
    setUnGroupedOffers(unGroupedOffers || []);
    setAppliedList(appliedOffer || []);
    setActiveOffers(activeOffers);
  }, [offersData, selectedCard, checkPreActiveOffer, formattedOffers]);

  const fetchOffers = useCallback(() => {
    const { isPlanKsa, isPlanKw } = checkModule;
    if (isPlanKw) {
      setLoading(true);
      const is5g = JSON.parse(Storage.get("is_category_type_5g", true));
      let API = null;
      if (is5g) {
        API = Offers.get5gAvailableOffers;
      } else {
        API = Offers.getAvailableOffers;
      }
      return API()
        .then((res) => {
          if (res?.data?.Offers) {
            setOffersData(res?.data?.Offers);
            setPreSelectedOffers(res?.data?.Offers);
            setLoading(false);
            setOffersFetchedInitially(true)
          }
        })
        .catch(() => {
          setOffersFetchedInitially(false)
          setModalLoader(false);
          setLoading(false);
        });
    }
  
    if (isPlanKsa) {
      const activeProductCodes = JSON.parse(Storage.get("pre-defined-plan-selected-product-code", true));
      if (activeProductCodes) {
        setLoading(true);
        return Offers.getAvailableOffers(activeProductCodes)
          .then((res) => {
            if (res?.data?.Offers) {
              setLoading(false);
              if (setOffersFetchedInitially) {
                setOffersFetchedInitially(true)
              }
              setOffersData(res?.data?.Offers);
              setPreSelectedOffers(res?.data?.Offers);
            }
          })
          .catch(() => {
            setLoading(false);
            if (setOffersFetchedInitially) {
              setOffersFetchedInitially(true)
            }
          });
      } else {
        if (setOffersFetchedInitially) {
          setOffersFetchedInitially(true)
        }
        return new Promise.resolve();
      }
    }
  }, [setPreSelectedOffers, setOffersFetchedInitially]);

  // useEffect(() => {
  //   fetchOffers();
  // }, [fetchOffers]);
  useEffect(() => {
    fetchOffers();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleApply = () => {
    setError(false);
    Storage.clear("promotionErrorStatus");
    let number = JSON.parse(Storage.get("reserved_number_local", true));
    setModalLoader(true);
    setLoading(true);
    Storage.set("promotionErrorStatus", true, true);
    Offers.checkPromoCode(promoCode, number?.MSISDN || null)
      .then((res) => {
        if (res?.status === 200) {
          Offers.applyPromoCode(promoCode, number?.MSISDN || null)
            .then((res) => {
              fetchOffers();
              let firebase_param = {
                offer_code: promoCode,
                plan_name: "",
                plan_code: "",
                product_code: ""
              }
              FirebaseAnalytics.offer_applied(firebase_param);
            })
            .catch((error) => {
              setModalLoader(false);
            });
        } else {
          Storage.clear("promotionErrorStatus");
          setModalLoader(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        setError(true);
        Storage.clear("promotionErrorStatus");
        setModalLoader(false);
        setLoading(false);
      });
  };

  const handleApplyPromoCode = (PromotionId, isApplied, key) => {
    handleAppliedOffers(key, isApplied ? "" : PromotionId);
    Storage.clear("pre-defined-plan-selected")
    setModalLoader(true);
    if (isApplied) {
      if (Storage.get("latest_offer_code_selected", true) === PromotionId) {
        Storage.clear("latest_offer_code_selected")
      }
      Offers.removeOffer(PromotionId)
        .then((response) => {
          fetchOffers().then(() => {
            FirebaseAnalytics.offer_removed();
            setLoading(false);
          }).catch(() => {
            setLoading(false);
          })
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      Storage.set("latest_offer_code_selected", PromotionId, true)
      Storage.set("is_custom_card_selected", false, true)
      let number = JSON.parse(Storage.get("reserved_number_local", true));
      Offers.applyOffer(PromotionId, number?.MSISDN || null)
        .then((response) => {
          fetchOffers();
        })
        .catch((err) => {
          setModalLoader(false);
        });
    }
  };

  const handleDeleteOffer = () => {
    if (itemToDelete) {
      handleApplyPromoCode(
        itemToDelete.PromotionId,
        itemToDelete.IsApplied,
        itemToDelete.GroupName
      )
    }
    toggleDeleteModal()
  }


  const isOfferError = (data) => {
    return !(selectedCard?.Promotions?.some((item) => item.PromotionCode === data.PromotionId) || false) && data.IsApplied
  }

  return (
    <>
      {isOffersModal && (
        <OfferModal
          activeOffers={activeOffers}
          isError={isError}
          unGroupedOffers={unGroupedOffers}
          appliedOffer={appliedOffer}
          offersList={offersList}
          promoCode={promoCode}
          selectedCard={selectedCard}
          setError={setError}
          setPromoCode={setPromoCode}
          handleApply={handleApply}
          modalLoader={modalLoader}
          fetchOffers={fetchOffers}
          toggleOffersModal={toggleOffersModal}
          setAppliedOffer={setAppliedOffer}
        />
      )}
      {isDeletePopup && <DeletePopup
        onClose={toggleDeleteModal}
        onDelete={handleDeleteOffer}
      />}
      {isLoading ? (
        <Skeleton width={"100%"} height={"46px"} />
      ) : (
        <>
          <div className="stm-sum-grid-offer">
            {appliedList.map((item) => (
              <>
                <div className="offer-wrapper">
                  <div className="stm-sum-block stm-sum-block-left">
                    {item?.PromoCode
                      ? Translations.keys[prefix + "Promo_code"] +
                      " (" +
                      item?.PromoCode +
                      ")"
                      : Translations.keys[
                      `applied_offer_title_${item?.PromotionId}`
                      ]}
                  </div>
                  <div className="stm-sum-block-right stm-sum-left-log">
                    <img
                      onClick={() => {
                        toggleDeleteModal()
                        setItemToDelete(item)
                      }
                      }
                      src={Delete}
                      alt=""
                    />
                  </div>
                </div>
                {isOfferError(item) && <p className="card-lower-text-error">
                  {Translations.keys["scr_3810_P_Not_available_with_current_plan_selection"]}
                </p>}
              </>
            ))}
          </div>
          <button onClick={toggleOffersModal} className="stm-sum-extras-btn">
            {Translations.keys[prefix + "choose_offer"]}
          </button>
        </>
      )}
    </>
  );
};

export default SummaryOfferSection;
